import styled from 'styled-components/macro'
import {
  AdvancedSearchSVG,
  CloseSVG,
  SearchSVG,
} from 'src/components/Icons/Basic'
import palette from 'src/designSystem/variables/palette'

export const SearchContainer = styled.div<{ $isExpanded?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  .search-bar {
    gap: ${({ $isExpanded }) => ($isExpanded ? '10px' : '0px')};
    transition: all 0.6s ease;
    ${({ $isExpanded }) =>
      $isExpanded && `flex: 1 1 auto; min-width: 0; max-width: 741px;`}
  }

  .search-icon-text {
    display: ${({ $isExpanded }) => ($isExpanded ? 'none' : 'block')};
    transition: display 0.6s ease;
  }

  .search-input {
    width: ${({ $isExpanded }) => ($isExpanded ? 'auto' : '0px')};
  }

  .search-option {
    border-left: ${({ $isExpanded }) =>
      $isExpanded ? `1px solid ${palette.neutral['100']}` : 'none'};
    width: ${({ $isExpanded }) => ($isExpanded ? 'fit-content' : '0px')};
    padding-left: ${({ $isExpanded }) => ($isExpanded ? '10px' : '0px')};
  }
`

export const SearchIcon = styled(SearchSVG)`
  height: 16px;
  width: 16px;
  flex-shrink: 0;
`

export const SearchIconButton = styled.div.attrs({
  className: 'search-icon-button',
})`
  height: 32px;
  width: fit-content;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
`

export const SearchIconText = styled.span.attrs({
  className: 'search-icon-text',
})`
  color: ${palette.neutral['500']};
`

export const AdvancedSearchButton = styled.div.attrs({
  classNames: ['floating-menu-button', 'advanced-search-button'],
})`
  cursor: pointer;
`
export const AdvancedSearchIcon = styled(AdvancedSearchSVG)`
  height: 16px;
  width: 16px;
  flex-shrink: 0;
`

export const SearchBar = styled.div.attrs({
  className: 'search-bar',
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 20px;
  justify-content: space-between;
  height: 32px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 0;
  padding-bottom: 0;
  background-color: white;
  border-color: ${palette.neutral['100']};
  overflow: hidden;
  border: 1px solid ${palette.neutral['100']};
`

export const SearchInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
`

export const SearchOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`

export const SearchOption = styled.div.attrs({
  className: 'search-option',
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  border-left: 1px solid ${palette.neutral['100']};
  height: 100%;
  overflow: hidden;
`

export const SearchInput = styled.input.attrs({
  className: 'search-input',
})`
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: ${palette.neutral['500']};
  pointer-events: auto;
  flex-grow: 1;
`

export const CloseIcon = styled(CloseSVG)`
  height: 10px;
  width: 10px;
  flex-shrink: 0;
  &:hover {
    cursor: pointer;
  }
`
